import { useCallback } from 'react';
import { AModal } from '../../../../components';
import { useToast } from '../../../../hooks/toast';
import { IDentalProcedureInsert } from '../../../../shared/interfaces';
import { Typography } from 'antd';
import { deleteDentalTreatmentItem } from '../../../../http';

interface IRemoveProcedureDentalProps {
  open: boolean;
  close: () => void;
  code: number | null;
  procedureInsert: IDentalProcedureInsert;
  setProceduresInsert: React.Dispatch<
    React.SetStateAction<IDentalProcedureInsert[]>
  >;
}

const RemoveProceduresDental: React.FC<IRemoveProcedureDentalProps> = ({
  open,
  close,
  code,
  procedureInsert,
  setProceduresInsert,
}) => {
  const { addToast } = useToast();
  const { Text } = Typography;

  const deleteProcedure = useCallback(async () => {
    if (code) {
      await deleteDentalTreatmentItem(procedureInsert.id)
        .then(() => {
          addToast({
            type: 'success',
            title: 'Sucesso',
            description: 'Procedimento removido',
          });
          setProceduresInsert((state) =>
            state.filter((x) => x.id !== procedureInsert.id),
          );
          close();
        })
        .catch((error) => {
          addToast({
            type: 'error',
            title: 'Erro',
            description: error.response.data.error ?? 'Erro ao remover.',
          });
        });
    } else {
      setProceduresInsert((state) =>
        state.filter((x) => x.id !== procedureInsert.id),
      );
      close();
    }
  }, [addToast, close, code, procedureInsert.id, setProceduresInsert]);

  return (
    <AModal
      open={open}
      close={close}
      title="Remover procedimento"
      onOk={() => deleteProcedure()}
      okText="Sim"
      cancelText="Não"
    >
      <Text>Tem certeza que deseja remover o procedimento?</Text>
    </AModal>
  );
};

export default RemoveProceduresDental;
